// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProviderAddressInfoDto } from './IProviderAddressInfoDto';
import {
    IProviderAddressInfoDtoFromJSON,
    IProviderAddressInfoDtoFromJSONTyped,
    IProviderAddressInfoDtoToJSON,
    IProviderAddressInfoDtoToJSONTyped,
} from './IProviderAddressInfoDto';

/**
 * 
 * @export
 * @interface IUpdateProviderDto
 */
export interface IUpdateProviderDto {
    /**
     * 
     * @type {string}
     * @memberof IUpdateProviderDto
     */
    facility_name: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateProviderDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateProviderDto
     */
    last_name?: string;
    /**
     * 
     * @type {Array<IProviderAddressInfoDto>}
     * @memberof IUpdateProviderDto
     */
    addresses: Array<IProviderAddressInfoDto>;
}

/**
 * Check if a given object implements the IUpdateProviderDto interface.
 */
export function instanceOfIUpdateProviderDto(value: object): value is IUpdateProviderDto {
    if (!('facility_name' in value) || value['facility_name'] === undefined) return false;
    if (!('addresses' in value) || value['addresses'] === undefined) return false;
    return true;
}

export function IUpdateProviderDtoFromJSON(json: any): IUpdateProviderDto {
    return IUpdateProviderDtoFromJSONTyped(json, false);
}

export function IUpdateProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_name': json['facility_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'addresses': ((json['addresses'] as Array<any>).map(IProviderAddressInfoDtoFromJSON)),
    };
}

export function IUpdateProviderDtoToJSON(json: any): IUpdateProviderDto {
    return IUpdateProviderDtoToJSONTyped(json, false);
}

export function IUpdateProviderDtoToJSONTyped(value?: IUpdateProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_name': value['facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'addresses': ((value['addresses'] as Array<any>).map(IProviderAddressInfoDtoToJSON)),
    };
}

